/**
 * Get the root element for a portal given an id. Creates
 * a root element if one doesn't already exist
 */
function getPortalRoot(id: string): HTMLElement | undefined {
  // Don't try to access the document if it doesn't exist for ssr
  if (typeof document === "undefined") return;

  const getPortalRoot = document.getElementById(id);

  if (!getPortalRoot) {
    // If the root element doesn't exist, create one and return it
    const rootElement = document.createElement("div");
    rootElement.setAttribute("id", id);
    return document.body.appendChild(rootElement);
  }

  // If the root element exists, return it
  return getPortalRoot;
}

export default getPortalRoot;
